// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FieldCheckBox_wrapper__MAJJ3","wrapperActive":"FieldCheckBox_wrapperActive__wmUH3","icon":"FieldCheckBox_icon__1xres","input":"FieldCheckBox_input__2rNhA"};